import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/leaflet-geosearch/leaflet-geosearch/node_modules/gatsby-theme-docz/src/base/Layout.js";
import Playground from '../components/Playground';
import Map from '../components/Map';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "openstreetmap-provider"
    }}>{`OpenStreetMap Provider`}</h1>
    <p>{`For more options and configurations, see the `}<a parentName="p" {...{
        "href": "http://wiki.openstreetmap.org/wiki/Nominatim"
      }}>{`OpenStreetMap Nominatim wiki`}</a>{`.`}</p>
    <Playground __position={0} __code={'<Map provider=\"OpenStreetMap\" />'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Map,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <Map provider="OpenStreetMap" mdxType="Map" />
    </Playground>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import { OpenStreetMapProvider } from 'leaflet-geosearch';

const provider = new OpenStreetMapProvider();

// add to leaflet
import { GeoSearchControl } from 'leaflet-geosearch';

map.addControl(
  new GeoSearchControl({
    provider,
    style: 'bar',
  }),
);
`}</code></pre>
    <h2 {...{
      "id": "authentication"
    }}>{`Authentication`}</h2>
    <p>{`Note that OpenStreetMap is open, but not free without limits. They do have a `}<a parentName="p" {...{
        "href": "https://operations.osmfoundation.org/policies/nominatim"
      }}>{`Usage Policy`}</a>{` just like the other providers. Provide the `}<inlineCode parentName="p">{`email`}</inlineCode>{` property to opt-in for authenticated requests.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`const provider = new OpenStreetMapProvider({
  params: {
    email: 'john@example.com', // auth for large number of requests
  },
});
`}</code></pre>
    <h2 {...{
      "id": "optional-parameters"
    }}>{`Optional parameters`}</h2>
    <p>{`OpenStreetMap Nominatim supports a number of `}<a parentName="p" {...{
        "href": "https://nominatim.org/release-docs/develop/api/Search/#parameters"
      }}>{`optional parameters`}</a>{`. As the api requires those parameters to be added to the url, they can be added to the `}<inlineCode parentName="p">{`params`}</inlineCode>{` key of the provider.`}</p>
    <p>{`All options defined next to the `}<inlineCode parentName="p">{`params`}</inlineCode>{` key, would have been added to the request body.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`const provider = new OpenStreetMapProvider({
  params: {
    'accept-language': 'nl', // render results in Dutch
    countrycodes: 'nl', // limit search results to the Netherlands
    addressdetails: 1, // include additional address detail parts
  },
});
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      